import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../store/store";
import { clearChat, getConversations, setChatActiveTab } from "../../store/slices/chat";
import { fetchDoctors } from "../../store/slices/doctors";
import { useCheckMobileScreen } from "../../hooks";
import Inbox from "./Inbox/Inbox";
import Chat from "./Chat";
import NavTab from "../../components/NavTab/NavTab";
import styles from "./Chat.module.scss";


const ChatPage = () => {
    const dispatch = useAppDispatch();
    const { chatActiveTab } = useAppSelector((state) => state.chat);
    const isMobile = useCheckMobileScreen();

    useEffect(() => {
        dispatch(fetchDoctors());
        dispatch(getConversations({ getFirstConversation: true, type: '' }));
        return () => {
            dispatch(clearChat());
        }
    }, [dispatch])

    return (
        <div className={styles.container}>
            {!isMobile ? <div className={styles.wrapper}>
                <Inbox />
                <Chat />
            </div> :
                <NavTab
                    tabs={['All Messages', "Chat"]}
                    activeTab={chatActiveTab}
                    cb={(idx: number) => dispatch(setChatActiveTab(idx))}
                >
                    {chatActiveTab === 0 ? (
                        <Inbox style={{ maxWidth: "100%", border: "1px solid #E3E3E3", borderRadius: "10px" }} />
                    ) : (
                        <Chat />
                    )}
                </NavTab>
            }
        </div>
    );
}

export default ChatPage;